module.exports = __webpack_public_path__ + "media/images/illustrations/location_truck_tracking_small-3caa80e3ee10240f2b555f60dba09366.svg";